import { collection, doc, getDoc, getDocs, limit, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { db } from "../apis/auth";

export function isWithinSchedule(ontime, offtime) {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const startMinutes = ontime.hrs * 60 + ontime.mins;
  const endMinutes = offtime.hrs * 60 + offtime.mins;

  if (startMinutes <= endMinutes) {
    // Schedule does NOT cross midnight (e.g. 08:00 to 17:00)
    return currentMinutes >= startMinutes && currentMinutes < endMinutes;
  } else {
    // Schedule crosses midnight (e.g. 18:00 to 06:00)
    return currentMinutes >= startMinutes || currentMinutes < endMinutes;
  }
}

export async function getDashboardMockData() {
  try {
    // ✅ Query for schedule document where name === "default"
    const schedulesQuery = query(
      collection(db(), "schedules"),
      where("name", "==", "default")
    );
    const querySnapshot = await getDocs(schedulesQuery);
    if (querySnapshot.empty) {
      return Promise.reject("No schedule document with name 'default' found");
    }

    // Get the first matching document (assuming there's only one)
    const scheduleDoc = querySnapshot.docs[0];
    const { on_time, off_time } = scheduleDoc.data();
    const isScheduled = isWithinSchedule(on_time, off_time);

    // ✅ Fetch dashboard_data
    const dashboardRef = doc(db(), "settings", "dashboard_data");
    const dashboardSnap = await getDoc(dashboardRef);

    if (dashboardSnap.exists()) {
      return Promise.resolve({
        ...dashboardSnap.data(),
        isScheduled,
        on_time,
        off_time
      });
    }

    return Promise.resolve({
      isScheduled,
      on_time,
      off_time
    });

  } catch (error) {
    return Promise.reject(error);
  }
}


export const handleSaveData = async (Data) => {
  try {
    const { in_schedule = [], out_schedule = [] } = Data;

    const cleanData = (schedule) =>
      schedule.map(({ tableData, ...rest }) => rest);  // destructure and exclude _data

    const data = {
      mockData: [
        ...cleanData(in_schedule),
        ...cleanData(out_schedule)
      ]
    };

    const docRef = doc(db(), "settings", "dashboard_data");

    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      await updateDoc(docRef, data);
      console.log("Document successfully updated!");
    } else {
      await setDoc(docRef, data);
      console.log("Document successfully added!");
    }
  } catch (e) {
    console.error("Error saving document: ", e);
  }
};
